import { render, staticRenderFns } from "./TabBox.vue?vue&type=template&id=e5c50432&scoped=true"
import script from "./TabBox.vue?vue&type=script&lang=js"
export * from "./TabBox.vue?vue&type=script&lang=js"
import style0 from "./TabBox.vue?vue&type=style&index=0&id=e5c50432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c50432",
  null
  
)

export default component.exports